// 特定商取引に関する法律 (Specified Commercial Transactions Act)
export const TextsForSCTA: React.FC = () => (
  <div>
    ※支払方法、サービス提供時期、及び撤回・解除については
    <a
      href="https://docs.unext.jp/pdf/tokusyo20120816.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="text-accent-primary underline"
    >
      こちら
    </a>
    を、支払時期は
    <a
      href="https://help.unext.jp/guide/detail/billing-timing-for-each-payment-method"
      target="_blank"
      rel="noopener noreferrer"
      className="text-accent-primary underline"
    >
      こちら
    </a>
    をご確認下さい。
  </div>
);
